// @ts-expect-error ts-migrate(2305) FIXME: Module '"flux-actions"' has no exported member 'cr... Remove this comment to see the full error message
import { createAction } from 'flux-actions';
import keyMirror from 'react-utils/keyMirror';
import { mapPayloadTo } from './utils';
export const TwoFactorAuthActionTypes = keyMirror({
  CLICKED_SETUP_2FA: null,
  STARTED_SETUP_2FA_FOR_LOGIN: null,
  SELECTED_2FA_METHOD: null,
  CONFIRMED_2FA_METHOD: null,
  CONFIRMED_2FA_METHOD_REQUEST: null,
  CONFIRMED_2FA_METHOD_SUCCESS: null,
  CONFIRMED_2FA_METHOD_FAILURE: null,
  COMPLETED_GA_REGISTRATION: null,
  CHANGED_VERIFICATION_CODE_ATTEMPT: null,
  CONFIRM_VERIFICATION_CODE_ATTEMPT: null,
  CONFIRMED_VERIFICATION_CODE_REQUEST: null,
  CONFIRMED_VERIFICATION_CODE_SUCCESS: null,
  CONFIRMED_VERIFICATION_CODE_FAILURE: null,
  COMPLETED_GA_VERIFICATION: null,
  COMPLETED_2FA_SETUP: null,
  CANCELLED_2FA_SETUP: null,
  CHANGED_SMS_REGISTRATION_NUMBER: null,
  CONFIRMED_SMS_NUMBER: null,
  COMPLETED_SMS_VERIFICATION: null,
  PRINTED_OR_SAVED_BACKUP_CODES: null,
  COMPLETED_BACKUP_CODES: null,
  REQUESTED_2FA_STATUS: null,
  FETCHED_2FA_STATUS_REQUEST: null,
  FETCHED_2FA_STATUS_SUCCESS: null,
  FETCHED_2FA_STATUS_FAILURE: null,
  TURNED_OFF_2FA: null,
  TURNED_OFF_2FA_REQUEST: null,
  TURNED_OFF_2FA_SUCCESS: null,
  TURNED_OFF_2FA_FAILURE: null,
  CLICKED_SETUP_2FA_BACKUP: null,
  CLOSED_SETUP_2FA_BACKUP: null,
  REQUESTED_2FA_GENERATE_BACKUP: null,
  GENERATED_2FA_BACKUP_REQUEST: null,
  GENERATED_2FA_BACKUP_SUCCESS: null,
  GENERATED_2FA_BACKUP_FAILURE: null,
  FETCHED_SETUP_PORTAL_2FA_STATUS_FAILURE: null,
  FETCHED_SETUP_PORTAL_2FA_STATUS_REQUEST: null,
  FETCHED_SETUP_PORTAL_2FA_STATUS_SUCCESS: null,
  USER_LOGIN_REQUIRED_FOR_2FA: null,
  REDIRECT_TO_LOGIN: null,
  REDIRECT_TO_SECONDARY_2FA_SETUP: null
});
export const requestTwoFactorAuthGenerateBackupCodes = createAction(TwoFactorAuthActionTypes.REQUESTED_2FA_GENERATE_BACKUP);
export const generateTwoFactorAuthBackupCodesRequest = createAction(TwoFactorAuthActionTypes.GENERATED_2FA_BACKUP_REQUEST);
export const generateTwoFactorAuthBackupCodesSuccess = createAction(TwoFactorAuthActionTypes.GENERATED_2FA_BACKUP_SUCCESS, payload => payload);
export const generateTwoFactorAuthBackupCodesFailure = createAction(TwoFactorAuthActionTypes.GENERATED_2FA_BACKUP_FAILURE, mapPayloadTo('error'));
export const setup2faBackup = createAction(TwoFactorAuthActionTypes.CLICKED_SETUP_2FA_BACKUP);
export const close2faBackup = createAction(TwoFactorAuthActionTypes.CLOSED_SETUP_2FA_BACKUP);
export const setup2fa = createAction(TwoFactorAuthActionTypes.CLICKED_SETUP_2FA, mapPayloadTo('precedence', 'stagedMethod'));
export const setup2faForLogin = createAction(TwoFactorAuthActionTypes.STARTED_SETUP_2FA_FOR_LOGIN, mapPayloadTo('portalId'));
export const selectMethod = createAction(TwoFactorAuthActionTypes.SELECTED_2FA_METHOD, mapPayloadTo('method'));
export const confirmMethod = createAction(TwoFactorAuthActionTypes.CONFIRMED_2FA_METHOD, mapPayloadTo('precedence', 'method'));
export const confirmMethodRequest = createAction(TwoFactorAuthActionTypes.CONFIRMED_2FA_METHOD_REQUEST);
export const confirmMethodSuccess = createAction(TwoFactorAuthActionTypes.CONFIRMED_2FA_METHOD_SUCCESS, mapPayloadTo('response'));
export const confirmMethodFailure = createAction(TwoFactorAuthActionTypes.CONFIRMED_2FA_METHOD_FAILURE, mapPayloadTo('error', 'context'));
export const completeGoogleAuthRegistration = createAction(TwoFactorAuthActionTypes.COMPLETED_GA_REGISTRATION);
export const changeVerificationCodeAttempt = createAction(TwoFactorAuthActionTypes.CHANGED_VERIFICATION_CODE_ATTEMPT, mapPayloadTo('precedence', 'codeAttempt'));
export const confirmVerificationCodeAttempt = createAction(TwoFactorAuthActionTypes.CONFIRM_VERIFICATION_CODE_ATTEMPT, mapPayloadTo('precedence', 'codeAttempt'));
export const confirmVerificationCodeRequest = createAction(TwoFactorAuthActionTypes.CONFIRMED_VERIFICATION_CODE_REQUEST);
export const confirmVerificationCodeSuccess = createAction(TwoFactorAuthActionTypes.CONFIRMED_VERIFICATION_CODE_SUCCESS, mapPayloadTo('config'));
export const confirmVerificationCodeFailure = createAction(TwoFactorAuthActionTypes.CONFIRMED_VERIFICATION_CODE_FAILURE, mapPayloadTo('error'));
export const completeGoogleAuthVerification = createAction(TwoFactorAuthActionTypes.COMPLETED_GA_VERIFICATION);
export const completeSetup = createAction(TwoFactorAuthActionTypes.COMPLETED_2FA_SETUP);
export const cancelSetup = createAction(TwoFactorAuthActionTypes.CANCELLED_2FA_SETUP);
export const changeSMSNumber = createAction(TwoFactorAuthActionTypes.CHANGED_SMS_REGISTRATION_NUMBER, mapPayloadTo('number'));
export const confirmSMSNumber = createAction(TwoFactorAuthActionTypes.CONFIRMED_SMS_NUMBER, mapPayloadTo('precedence', 'number'));
export const completeSMSVerification = createAction(TwoFactorAuthActionTypes.COMPLETED_SMS_VERIFICATION);
export const printedOrSavedBackupCodes = createAction(TwoFactorAuthActionTypes.PRINTED_OR_SAVED_BACKUP_CODES);
export const completeBackupCodes = createAction(TwoFactorAuthActionTypes.COMPLETED_BACKUP_CODES);
export const requestTwoFactorAuthStatus = createAction(TwoFactorAuthActionTypes.REQUESTED_2FA_STATUS);
export const fetchTwoFactorAuthStatusRequest = createAction(TwoFactorAuthActionTypes.FETCHED_2FA_STATUS_REQUEST);
export const fetchTwoFactorAuthStatusSuccess = createAction(TwoFactorAuthActionTypes.FETCHED_2FA_STATUS_SUCCESS, mapPayloadTo('status'));
export const fetchTwoFactorAuthStatusFailure = createAction(TwoFactorAuthActionTypes.FETCHED_2FA_STATUS_FAILURE, mapPayloadTo('error'));
export const turnOffTwoFactorAuth = createAction(TwoFactorAuthActionTypes.TURNED_OFF_2FA, mapPayloadTo('precedence', 'secondaryEnabled'));
export const turnOffTwoFactorAuthRequest = createAction(TwoFactorAuthActionTypes.TURNED_OFF_2FA_REQUEST);
export const turnOffTwoFactorAuthSuccess = createAction(TwoFactorAuthActionTypes.TURNED_OFF_2FA_SUCCESS, mapPayloadTo('status'));
export const turnOffTwoFactorAuthFailure = createAction(TwoFactorAuthActionTypes.TURNED_OFF_2FA_FAILURE, mapPayloadTo('error', 'precedence', 'secondaryEnabled'));
export const fetchSetupPortalTwoFactorStatusRequest = createAction(TwoFactorAuthActionTypes.FETCHED_SETUP_PORTAL_2FA_STATUS_REQUEST);
export const fetchSetupPortalTwoFactorStatusSuccess = createAction(TwoFactorAuthActionTypes.FETCHED_SETUP_PORTAL_2FA_STATUS_SUCCESS, mapPayloadTo('status'));
export const fetchSetupPortalTwoFactorStatusFailure = createAction(TwoFactorAuthActionTypes.FETCHED_SETUP_PORTAL_2FA_STATUS_FAILURE, mapPayloadTo('error', 'portalId'));
export const requireUserLogin = createAction(TwoFactorAuthActionTypes.USER_LOGIN_REQUIRED_FOR_2FA);
export const redirectToLogin = createAction(TwoFactorAuthActionTypes.REDIRECT_TO_LOGIN);
export const redirectToSecondary2faSetup = createAction(TwoFactorAuthActionTypes.REDIRECT_TO_SECONDARY_2FA_SETUP, mapPayloadTo('stagedMethod'));